export enum BifMetadataType {
    BifCreationProcess = "BifCreationProcess",
    BifWritebackProcess = "BifWritebackProcess",
}